import React, { useEffect, useState } from 'react';
import { trackPublicCTA } from '../utils/publicFunnelTracking';
import { trackPinterest } from '../utils/pinterestTag';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DemoBookingModal({ isOpen, onClose, source = 'cta_button' }) {
  const [form, setForm] = useState({ name: '', phone: '', email: '', school_name: '', city: '' });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      trackPublicCTA({
        source_page: source,
        cta_id: `${source}_open`,
        cta_label: 'Open Demo Booking Modal',
        destination: 'demo_booking_modal'
      });
    }
  }, [isOpen, source]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      setError('Name aur Phone number zaruri hai');
      return;
    }
    if (form.phone.replace(/\D/g, '').length < 10) {
      setError('Valid 10-digit phone number daalen');
      return;
    }
    // Email validation (typo catcher)
    if (form.email) {
      const e2 = form.email.trim().toLowerCase();
      const emailRe = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const tldRe = /\.(com|in|org|net|edu|gov|io|co|info|biz|me|app|dev|tech|store|online|site)$/i;
      if (!emailRe.test(e2)) {
        setError('Email सही नहीं है — दोबारा check करें (e.g. you@gmail.com)');
        return;
      }
      if (!tldRe.test(e2)) {
        setError('Email का domain (जैसे .com / .in) सही नहीं है। आपने शायद टाइप करते समय गलती की।');
        return;
      }
    }

    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/demo/book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, source })
      });
      const data = await res.json();
      if (data.success) {
        setResult(data);
        trackPublicCTA({
          source_page: source,
          cta_id: `${source}_submit`,
          cta_label: 'Submit Demo Booking',
          destination: 'demo_booked',
          phone: form.phone,
          meta: { school_name: form.school_name }
        });
        if (window.gtag) window.gtag('event', 'demo_booked', { event_category: 'lead', source });
        if (window.fbq) window.fbq('track', 'Lead', { content_name: 'demo_booking', content_category: source });
        // Pinterest Enhanced Match — hashed email + phone
        trackPinterest('lead', {
          lead_type: 'demo_booking',
          line_items: [{ product_name: 'Shiksha Mitra Demo', product_category: source }]
        }, { email: form.email, phone: form.phone });
      } else {
        setError(data.detail || 'Kuch gadbad ho gayi. Dobara try karein.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }
    setLoading(false);
  };

  const handleClose = () => {
    setForm({ name: '', phone: '', email: '', school_name: '', city: '' });
    setResult(null);
    setError('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" data-testid="demo-booking-modal">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" onClick={handleClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-5 text-white">
          <button onClick={handleClose} className="absolute top-4 right-4 text-white/80 hover:text-white text-xl" data-testid="demo-modal-close">&times;</button>
          <h3 className="text-xl font-bold" data-testid="demo-modal-title">
            {result ? 'Demo Ready!' : 'Free Demo Book Karein'}
          </h3>
          <p className="text-sm text-white/80 mt-1">
            {result ? 'WhatsApp par credentials bhej diye hain' : 'Apni details daalein — 2 minute mein demo milega'}
          </p>
        </div>

        <div className="p-6">
          {!result ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Aapka Naam *</label>
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Jaise: Vikas Garg"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="demo-name-input"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp Number *</label>
                <input
                  type="tel"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  placeholder="10 digit number"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="demo-phone-input"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="example@gmail.com"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="demo-email-input"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">School ka Naam</label>
                <input
                  type="text"
                  value={form.school_name}
                  onChange={(e) => setForm({ ...form, school_name: e.target.value })}
                  placeholder="Jaise: Delhi Public School"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="demo-school-input"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
                <input
                  type="text"
                  value={form.city}
                  onChange={(e) => setForm({ ...form, city: e.target.value })}
                  placeholder="Jaise: Lucknow"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="demo-city-input"
                />
              </div>

              {error && (
                <div className="bg-red-50 text-red-600 text-sm px-4 py-2 rounded-lg" data-testid="demo-error">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3.5 bg-orange-500 text-white rounded-xl font-bold text-lg hover:bg-orange-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="demo-submit-btn"
              >
                {loading ? 'Bhej rahe hain...' : 'WhatsApp par Demo Credentials Bhejein'}
              </button>
              
              <p className="text-center text-xs text-gray-400">
                Aapka data safe hai. Hum spam nahi karte.
              </p>
            </form>
          ) : (
            /* Success State */
            <div className="text-center space-y-4" data-testid="demo-success">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              
              <h4 className="text-lg font-bold text-gray-800">Demo Ready!</h4>
              <p className="text-sm text-gray-500">
                {result.whatsapp_sent 
                  ? 'WhatsApp par credentials bhej diye hain. Check karein!' 
                  : 'Neeche apne demo credentials hain:'}
              </p>

              {/* Credentials Card */}
              <div className="bg-gray-50 rounded-xl p-4 border-2 border-dashed border-orange-300 text-left" data-testid="demo-credentials">
                <p className="text-xs text-gray-500 mb-2 font-medium">LOGIN CREDENTIALS:</p>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Phone:</span>
                    <span className="font-bold text-gray-800" data-testid="demo-cred-phone">{result.demo_phone}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Password:</span>
                    <span className="font-bold text-gray-800" data-testid="demo-cred-password">{result.demo_password}</span>
                  </div>
                </div>
              </div>

              <a
                href="/login"
                className="block w-full py-3 bg-orange-500 text-white rounded-xl font-bold text-center hover:bg-orange-600 transition"
                data-testid="demo-login-btn"
              >
                Abhi Login Karein →
              </a>
              
              <button
                onClick={handleClose}
                className="text-sm text-gray-400 hover:text-gray-600"
              >
                Baad mein karenge
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
